import { PerformanceReports } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'sonner';
import { downloadIncidentsReportEnd } from './actionCreators';
import type * as Action from './actions';
import { ReportsActionTypes } from './reportsActionTypes';

const env = Environment.getInstance().getEnvironment();
const reportsRequester = new PerformanceReports({ host: env.herbieApiHost });

const downloadReportFile = (blob: Blob, name: string, startInMilli: number, endInMilli: number, format = 'xls'): void => {
  const startTimeStr = moment(startInMilli).format('YYMMDD');
  const endTimeStr = moment(endInMilli).format('YYMMDD');
  const periodStr = startTimeStr === endTimeStr ? startTimeStr : `${startTimeStr}_${endTimeStr}`;
  const filename = `Cobli_${periodStr}_${name}.${format}`;
  saveAs(blob, filename);
};

export function* requestDownloadIncidentsReportSaga(action: Action.DownloadIncidentsReportRequest) {
  const { start, end } = action.payload;

  try {
    const reportBlob: Blob = yield call(reportsRequester.getIncidentsReport, start, end);
    downloadReportFile(reportBlob, 'alertas', start, end);
  } catch (err) {
    toast.error('Ops! O sistema apresentou um erro e não foi possível exportar o relatório, tente novamente.');
  } finally {
    yield put(downloadIncidentsReportEnd());
  }
}

export function* ReportsSagasListener() {
  yield all([takeLatest(ReportsActionTypes.DOWNLOAD_INCIDENTS_REPORT_REQUEST, requestDownloadIncidentsReportSaga)]);
}
